<template>
  <Dialog :modelValue="props.modelValue" @update:modelValue="emit('update:modelValue', $event)" @close="emit('close')">
    <div class="dialog">
      <div class="dialog-title">
        <img :src="ruleDialogTitleImg" alt="ruleDialogTitle">
      </div>
      <div class="dialog-content-wrap">
        <div class="dialog-content">{{ t('halloween.howToPlayBody') }}</div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue'
import Dialog from '../index.vue'
import RuleDialogTitleMap from '@/views/act/halloween/assets/img/ruleTitle'
import { useI18n } from 'vue-i18n'
const { locale, t } = useI18n()

const ruleDialogTitleImg = computed(() => {
  return RuleDialogTitleMap[locale.value] || RuleDialogTitleMap.en
})

const emit = defineEmits(['update:modelValue', 'close'])
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
})
</script>


<style scoped lang="less">
.dialog {
  overflow: hidden;
  .dialog-title {
    width: 424px;
    height: 77px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url('~@/views/act/halloween/assets/img/dialog-title-bg.png') no-repeat center center / 100% 100%;
    margin: 0 auto;
    margin-top: -10px;
    img {
      height: 65px;
      margin-top: 10px;
    }
  }
  .dialog-content-wrap {
    width: 608px;
    height: 396px;
    margin: 0 auto;
    margin-top: 30px;
    padding: 20px 30px;
    background: url('~@/views/act/halloween/assets/img/dialog-inner-bg.png') no-repeat center center / 100% 100%;
    .dialog-content {
      height: 100%;
      overflow-y: auto;
      color: #fff;
      font-size: 20px;
      line-height: 1.5;
      text-align: left;
      white-space: pre-wrap;
    }
  }
}
</style>